const { createMachine } = require("xstate");
const actions = require("./actions");
const guards = require("./guards");
const services = require("./services");

const EditCorrectiveActionsMachine = createMachine(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5SQJYBcC0BjA9gJzzCzRQDcwMBDYlHAO1gDoUIAbMAYgBkB5AQQAiAbQAMAXUSgADjljpadSSAAeiAIwjGADgAsAZhEBOXQDYtRgKw6dWgDQgAnuoOMR1wwCZ9IvQHYzHhYAvkH2qJi4BEQk5FQ09ExYABZEANYABBCUaJQcohJIIDJyJPRKqggYHh6+jCY2vlqGOiYWhgYWHvZOCIEmjBaDenqevr46huO+IWEQ6Nj4hDSx1KUMjMlpmdm5QmoF0rLyZYUVHnpajB5qWr4WejUi5jZ2joh9A0MjNeOTOjPgOYRRbRMgUVYKJhgAC2UjQDg4AFUAHK8QT5JTFY6KU6IDAXHSMAyGNw6EQiXzXNRdN4IcwDLQeEyGP5aNSdNTTUKA+aRJYxcHxdYwuEItHCcSYo5rcp4nSUxjyowmB4qkzs149c5qAaNamGQZWEZ6YLc8ILKLLQVrKGw+EcQQCAD6AEkACoAUQAshjCliZbjKjcLFc9PodJ0PM0JmpuogbIZtJSxg0fuqAea+aCVkKmHQcGh0iL7Sjxb7DiUFLKEHp1XVmTVdCyxiM43TNBZGczWezrlzZryQVa4jbGPnC8WxfwJQcitKq4GWh5XFoTOqma17mG29rdWyo4b9O0M0CLfywSPIWOC0W7QjHa7PT7JX75ydQGdO4qw8mRGodF49xtgmSY-H4vgGiSHgnoOloCpeCSMJQEAQOk6AwkhKEoHQUBoWgMIOgAQnwyICDwyJOgASh6ACKiIegAyp6M5SpW74qHi4zLk81wRn4zL1L4ba+P+RJqCYNTnBJJpeDBwJwReEKIchqHodCmFzDheEEQIjEAMKUS6AAKbouuRTp6QAEiRADiHosa+bE4h+8YUlcJKUno7IiBYrSGMJ7KMBBwYvG4WjhXJZ7ZtaV4qdp6kqdhuFqRwBkenwnqPt65Zzk51YYJ0iprtSJr1OqEYmG2ajibUUltBMYxMsYkVZsOSnrHFakaUl8VIkZAgZR6TqEel1GUU6bo8AA0h6yI5f6C4uZUAGaGS-heH+Jo+EJtLVWoibUuuOhqLWx03C1Q7we1TCdfhCVYVpKUegAGkZLqURlZkUQNmUMR6XAenpzHzW+zkcTWTSuBYFInWuIwaP4baMpcgSMlYrQmOStwXQpOajrdGGJY9d0cNZpEA+NboAJpGUNVm2fZIN5YuTxFc84nQ5S9R6G27R6NoW4iGulJRlGOPnnjsUofF3XEwRem8H9TPYvlTQo9UFKrr4JrtJVtLGLUTzVdrUYBI04vRQhHXS11WCENkYC9RA9BgMwdCkDgqSu3bYAO1FbVCsrAZLSMlyMpyYZktUEyauogQduBJ0+cbvkWwH+M23dGz2-hvVgAQ+CMFIrDZAAZvg6k+37rVXYHL4Virgb4iGzRNWSFjiQ0PO7aHVzjBjJgiRYlJaGntcZ6pWf53g+AcNRbqUVTQeLeD+IsrqcOmFoVgnVVLRh2Sa4ST4+3MmPim5hs9ClygeDQuklAAEaUHQzt0KlJF6f9Tp8MRpHkcvdiFQMDJgZB4JoxhrhaFrP5WkLZvyY2KtJLy-wzSnhrhfUcuA6A3zvg-Z+r96BERImROa9dcqNyWiApkAwWitF8CIa4fh2Q7huH3J4tZ1S+V8noEI3J8wQDgEoTMl1MGQlYpQ1ezR+jVA8JrQeOtaxtgwGSRgngALa2MK0LyrRz6S0QiwdgEjg7g2HkFe4JIJLbwYULZowEZEqj-PcaqYZDDUj0TFRCmwsAZCyDkYxK8KheUVDYXyZgSSdh8HrLU9w1EMIYXxfwBoLgeKtraUUASgF4nEpcbWAkwwd2qm0HaPQ1raHMFrCYcNwGpOuteCcd5Mlg0-MuEkBoT5tD8HInQwE3LhSeIPKpKpwGmgHPJCWnjraTxhE0-K+9FQUgkmSE60M-BtisXUNwx9bhtE7LUy+BN7qaWSndWZgY5FBUcTYJkbJ9o1Sqow-m9x9DUiMFxMw+yJ4yyrrnNSZyqEI0VM48kNxB7Q32lVJkIYk7+EYXxACahPlS2mepae+B-mrx1LofQ6pbjnGgTo2OCB-wMLqMdMkDxxIXHEkirx19b73yfi-N+GLgEiUJG0qMwx9xFLbB3EMbghatH-BoNxo8+FAA */
    predictableActionArguments: true,

    id: "edit-corrective-actions",

    states: {
      idle: {
        on: {
          LOAD: {
            target: "check data",
            actions: "saveLoadRequest",
          },
        },
      },

      "check data": {
        always: [
          {
            target: "empty",
            cond: "correctiveActionsEmpty",
          },
          "not empty",
        ],
      },

      empty: {
        on: {
          UNLOAD: {
            target: "idle",
            actions: "resetLoadRequest",
          },

          LOAD: {
            target: "check data",
            actions: "saveLoadRequest",
          },

          ADD_ITEM: "add item.adding item",
        },
      },

      "not empty": {
        on: {
          UNLOAD: {
            target: "idle",
            actions: "resetLoadRequest",
          },

          LOAD: {
            target: "check data",
            actions: "saveLoadRequest",
          },

          ADD_ITEM: "add item.adding item",
        },
      },

      "add item": {
        states: {
          "adding item": {
            on: {
              ABANDON_REQUESTED: "#edit-corrective-actions.confirm abandon",

              DESCRIPTION_CHANGED: {
                target: "adding item",
                internal: true,
                actions: "saveDescription",
              },

              CREATE_ITEM: {
                target: "create item",
                cond: "validChangeSet",
              },

              UPDATE_BEARER_TOKEN: {
                target: "adding item",
                internal: true,
                cond: "validToken",
                actions: "saveToken",
              },

              EXPIRATION_DATE_SELECTED: {
                target: "adding item",
                internal: true,
                actions: "saveExpirationDate",
              },

              CLOSE: {
                target: "#edit-corrective-actions.check data",
                cond: "noChanges",
                actions: ["resetAddItemRequest", "resetChangeSet"],
              },

              HANDLER_TYPE_CHANGED: {
                target: "adding item",
                internal: true,
                actions: "saveHandlerType",
              },
            },
          },

          "create item": {
            invoke: {
              src: "createCorrectiveAction",
              id: "create-corrective-action",

              onDone: {
                target: "adding item",
                actions: [
                  "resetChangeSet",
                  "flagChanges",
                  "saveReturnedCorrectiveActions",
                ],
              },

              onError: "error",
            },
          },

          error: {
            entry: "saveError",

            on: {
              RETRY: "create item",
            },
          },
        },

        initial: "adding item",
      },

      "confirm abandon": {
        on: {
          CANCEL_ABANDON: "add item.adding item",
          ABANDON: {
            target: "check data",
            actions: ["resetAddItemRequest", "resetChangeSet"],
          },
        },
      },
    },

    initial: "idle",
    context: {
      loadRequest: undefined,
      corrective_actions: [],
      authentication: undefined,
      error: undefined,
      changeSet: undefined,
      changesHappened: false,
    },
  },
  {
    actions: actions,
    guards: guards,
    services: services,
  },
);

export { EditCorrectiveActionsMachine };
